import { NavLinks } from './NavLinks';

export const DesktopNavbar = () => (
  <nav className="hidden lg:flex flex-1 justify-evenly items-center ">
    <NavLinks />
  </nav>
);
